/* GetMindly, motyw Shopify. Bez bibliotek. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var drawer = $('#drawer');
  var overlay = $('#overlay');
  var lastFocus = null;
  var onCartPage = document.body.classList.contains('template-cart');

  /* menu mobilne */
  var header = $('[data-header]');
  var menuBtn = $('[data-menu-toggle]');
  function setMenu(open) {
    if (!header || !menuBtn) { return; }
    header.classList.toggle('open', open);
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuBtn.textContent = open ? 'Zamknij' : 'Menu';
  }
  if (menuBtn) {
    menuBtn.addEventListener('click', function () { setMenu(!header.classList.contains('open')); });
    $$('#menu a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  }

  /* toast */
  var toastTimer = null;
  function toast(text) {
    var t = $('#toast');
    if (!t) { return; }
    t.textContent = text;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3500);
  }

  /* koszyk: otwieranie i zamykanie */
  function focusables() { return $$('a[href], button:not([disabled]), input, summary', drawer); }
  function openCart() {
    if (!drawer) { return; }
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    if (overlay) { overlay.classList.add('on'); }
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lock');
    var c = $('#cart-close');
    if (c) { c.focus(); }
  }
  function closeCart() {
    if (!drawer) { return; }
    drawer.classList.remove('open');
    if (overlay) { overlay.classList.remove('on'); }
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lock');
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }
  function setCount(n) {
    n = parseInt(n, 10) || 0;
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.classList.toggle('on', n > 0); });
    $$('[data-cart-open]').forEach(function (a) { a.setAttribute('aria-label', 'Koszyk, pozycji: ' + n); });
  }
  function renderDrawer(html) {
    if (!html) { return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('cart-drawer-inner');
    var cur = document.getElementById('cart-drawer-inner');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      setCount(fresh.getAttribute('data-count'));
    }
  }
  function cartPost(path, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) { throw new Error(d.description || d.message || 'Nie udało się zaktualizować koszyka.'); }
        return d;
      });
    });
  }
  function addToCart(items, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return cartPost('cart/add.js', { items: items })
      .then(function (d) {
        if (onCartPage || !drawer) { window.location.href = root + 'cart'; return; }
        renderDrawer(d.sections && d.sections['cart-drawer']);
        openCart();
      })
      .catch(function (e) { toast(e.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var add = t.closest('[data-add]');
    if (add) {
      e.preventDefault();
      var vid = add.getAttribute('data-variant-id');
      if (vid) { addToCart([{ id: Number(vid), quantity: 1 }], add); }
      return;
    }
    var open = t.closest('[data-cart-open]');
    if (open && drawer && !onCartPage) { e.preventDefault(); openCart(); return; }
    if (t.closest('#cart-close') || t === overlay || t.closest('[data-close]')) { closeCart(); return; }

    var chg = t.closest('#drawer [data-change]');
    if (chg) {
      e.preventDefault();
      cartPost('cart/change.js', { id: chg.getAttribute('data-key'), quantity: Number(chg.getAttribute('data-qty')) })
        .then(function (d) { renderDrawer(d.sections && d.sections['cart-drawer']); })
        .catch(function (err) { toast(err.message); });
      return;
    }

    if (t.closest('[data-discount-apply]')) {
      e.preventDefault();
      var scope = t.closest('[data-cart-form]');
      var inp = scope && $('[data-discount-input]', scope);
      var code = inp ? inp.value.trim() : '';
      if (code) { window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart'); }
      return;
    }

    /* potrzeby -> rekomendacja */
    var need = t.closest('[data-need]');
    if (need) {
      $$('[data-need]').forEach(function (b) { b.setAttribute('aria-pressed', b === need ? 'true' : 'false'); });
      var tpl = $('template[data-panel="' + need.getAttribute('data-need') + '"]');
      var res = $('[data-result]');
      if (tpl && res) {
        var h = document.createElement('h3');
        h.textContent = 'Na początek: ' + (need.getAttribute('data-title') || '').toLocaleLowerCase('pl');
        res.innerHTML = '';
        res.appendChild(h);
        res.insertAdjacentHTML('beforeend', tpl.innerHTML);
      }
      return;
    }

    /* galeria */
    var thumb = t.closest('[data-thumb]');
    if (thumb) {
      var idx = Number(thumb.getAttribute('data-thumb'));
      var g = thumb.closest('[data-gallery]');
      $$('[data-slide]', g).forEach(function (s, i) { s.hidden = i !== idx; });
      $$('[data-thumb]', g).forEach(function (b) { b.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('open')) { return; }
    if (e.key === 'Escape') { closeCart(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) { return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* formularz produktu */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('[data-product-form]')) {
      e.preventDefault();
      var fd = new FormData(f);
      var id = Number(fd.get('id'));
      var q = parseInt(fd.get('quantity'), 10) || 1;
      if (id) { addToCart([{ id: id, quantity: q }], $('[data-atc-main]', f)); }
    }
  });

  /* warianty produktu */
  var pform = $('[data-product-form]');
  var vjson = $('[data-variants]');
  if (pform && vjson) {
    var variants = [];
    try { variants = JSON.parse(vjson.textContent); } catch (err) { variants = []; }
    var selects = $$('[data-option-index]', pform);
    var update = function () {
      var chosen = selects.map(function (s) { return s.value; });
      var v = variants.filter(function (x) { return chosen.every(function (c, i) { return x.options[i] === c; }); })[0];
      var mainBtn = $('[data-atc-main]', pform);
      var stickyBtn = $('[data-sticky-btn]');
      if (!v) {
        [mainBtn, stickyBtn].forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Niedostępny'; } });
        return;
      }
      $('[data-variant-input]', pform).value = v.id;
      [mainBtn, stickyBtn].forEach(function (b) {
        if (b) { b.disabled = !v.available; b.textContent = v.available ? 'Dodaj do koszyka' : 'Niedostępny'; }
      });
      $$('[data-price] .price, [data-price-sticky] .price').forEach(function (p) { p.textContent = v.price; });
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', window.location.pathname + '?variant=' + v.id);
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* przyklejony przycisk na telefonie */
  var sticky = $('[data-sticky]');
  var mainAtc = $('[data-atc-main]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    new IntersectionObserver(function (en) {
      var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('on', past);
    }).observe(mainAtc);
  }

  /* rekomendacje produktów */
  $$('[data-recommendations]').forEach(function (el) {
    if ($('.card', el)) { return; }
    var url = el.getAttribute('data-url');
    if (!url) { return; }
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.querySelector('.card')) { el.innerHTML = fresh.innerHTML; }
      else { el.remove(); }
    }).catch(function () { el.remove(); });
  });

  /* filtry kolekcji */
  var ff = $('[data-filter-form]');
  if (ff) {
    ff.addEventListener('change', function () {
      if (ff.requestSubmit) { ff.requestSubmit(); } else { ff.submit(); }
    });
  }

  /* etykieta oddechu */
  var breath = $('[data-breath]');
  if (breath) {
    if (reduce) { breath.textContent = 'Oddychaj'; }
    else {
      var inhale = true;
      setInterval(function () { inhale = !inhale; breath.textContent = inhale ? 'Wdech' : 'Wydech'; }, 4000);
    }
  }

  /* scroll reveal */
  var els = $$('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('in'); });
  }
})();
